import { Divider, HighlightTitle } from '@/components'

import styles from './PaymentDetails.module.scss'

export const PaymentDetails = ({ text, paymentData }) => {
  return (
    <div className={styles.paymentDetails}>
      <div className={styles.paymentDetails__consultation}>
        <p className={styles.paymentDetails__text}>Se você fez</p>

        <Divider />

        <HighlightTitle icon="equifax-file-analysis-2" text={<b>{text}</b>} />
      </div>

      <div
        className={`${styles.paymentDetails__consultation} ${styles['paymentDetails__consultation--red']}`}
      >
        <p className={styles.paymentDetails__text}>Você vai pagar:</p>

        <Divider />

        {paymentData.map(({ icon, text }, index) => (
          <HighlightTitle
            iconColor="white"
            icon={icon}
            text={<b>{text}</b>}
            key={`payment-details-${index}`}
          />
        ))}
      </div>
    </div>
  )
}
